import { render, staticRenderFns } from "./UserFileUpload.vue?vue&type=template&id=9c58a0bc&scoped=true&"
import script from "./UserFileUpload.vue?vue&type=script&lang=js&"
export * from "./UserFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./UserFileUpload.vue?vue&type=style&index=0&id=9c58a0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c58a0bc",
  null
  
)

export default component.exports